// Generated by purs version 0.13.8
"use strict";
var Color = require("../Color/index.js");
var Color_Blending = require("../Color.Blending/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_MonadZero = require("../Control.MonadZero/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Enum = require("../Data.Enum/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_EuclideanRing = require("../Data.EuclideanRing/index.js");
var Data_Filterable = require("../Data.Filterable/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Lens_Getter = require("../Data.Lens.Getter/index.js");
var Data_Lens_Internal_Forget = require("../Data.Lens.Internal.Forget/index.js");
var Data_List = require("../Data.List/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unfoldable1 = require("../Data.Unfoldable1/index.js");
var Lunarbox_Data_Dataflow_Class_Substituable = require("../Lunarbox.Data.Dataflow.Class.Substituable/index.js");
var Lunarbox_Data_Dataflow_Type = require("../Lunarbox.Data.Dataflow.Type/index.js");
var Lunarbox_Data_Editor_Node = require("../Lunarbox.Data.Editor.Node/index.js");
var Lunarbox_Data_Editor_Node_NodeId = require("../Lunarbox.Data.Editor.Node.NodeId/index.js");
var Lunarbox_Data_Editor_Node_PinLocation = require("../Lunarbox.Data.Editor.Node.PinLocation/index.js");
var Lunarbox_Math_SeededRandom = require("../Lunarbox.Math.SeededRandom/index.js");
var CombinableColor = function (x) {
    return x;
};
var unknownColor = Color.rgb(52)(235)(222);
var prettify = function (type$prime) {
    var variables = function (v) {
        if (v instanceof Lunarbox_Data_Dataflow_Type.TConstant) {
            return Data_Foldable.foldMap(Data_Foldable.foldableArray)(Data_List_Types.monoidList)(variables)(v.value1);
        };
        if (v instanceof Lunarbox_Data_Dataflow_Type.TVariable) {
            return Control_Applicative.pure(Data_List_Types.applicativeList)(v.value1);
        };
        throw new Error("Failed pattern match at Lunarbox.Capability.Editor.Type (line 108, column 3 - line 108, column 37): " + [ v.constructor.name ]);
    };
    var free = variables(type$prime);
    var freeCount = Data_List.length(free);
    var alphabet = Data_Functor.map(Data_Functor.functorArray)(Data_String_CodeUnits.singleton)(Data_Enum.enumFromTo(Data_Enum.enumChar)(Data_Unfoldable1.unfoldable1Array)("a")("z"));
    var alphabetSize = Data_Array.length(alphabet);
    var subst = Lunarbox_Data_Dataflow_Class_Substituable.Substitution(Data_Map_Internal.fromFoldable(Lunarbox_Data_Dataflow_Type.ordTVarName)(Data_List_Types.foldableList)(Data_List.mapWithIndex(function (index) {
        return function (name) {
            return Data_Tuple.Tuple.create(name)(new Lunarbox_Data_Dataflow_Type.TVariable(true, (function () {
                var $$char = Lunarbox_Data_Dataflow_Type.TVarName(Data_Maybe.fromMaybe(Data_Show.show(Lunarbox_Data_Dataflow_Type.tvarShow)(name))(Data_Array.index(alphabet)(Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(index)(alphabetSize))));
                var $14 = index < alphabetSize;
                if ($14) {
                    return $$char;
                };
                return Data_Semigroup.append(Lunarbox_Data_Dataflow_Type.semigroupTVarName)($$char)(Lunarbox_Data_Dataflow_Type.TVarName(Data_Show.show(Data_Show.showInt)(Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(index)(alphabetSize))));
            })()));
        };
    })(free)));
    return Lunarbox_Data_Dataflow_Class_Substituable.apply(Lunarbox_Data_Dataflow_Class_Substituable.typeSubst)(subst)(type$prime);
};
var pinLocations = function (node) {
    var output = Data_Functor.voidRight(Data_List_Types.functorList)(Lunarbox_Data_Editor_Node_PinLocation.OutputPin.value)(Control_MonadZero.guard(Data_List_Types.monadZeroList)(Lunarbox_Data_Editor_Node.hasOutput(node)));
    var inputs = Data_List.mapWithIndex(function (index) {
        return Data_Function["const"](new Lunarbox_Data_Editor_Node_PinLocation.InputPin(index));
    })(Data_Lens_Getter.view(Lunarbox_Data_Editor_Node["_nodeInputs"](Data_Lens_Internal_Forget.strongForget))(node));
    return Data_Semigroup.append(Data_List_Types.semigroupList)(output)(inputs);
};
var newtypeCc = new Data_Newtype.Newtype(function (n) {
    return n;
}, CombinableColor);
var inputNodeType = function (v) {
    return function (id) {
        return function (ty) {
            var inputIndex = Data_List.findIndex(function (v1) {
                return Data_Eq.eq(Lunarbox_Data_Editor_Node_NodeId.eqNodeId)(id)(v1);
            })(v.inputs);
            var v1 = Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(Data_List.index(Lunarbox_Data_Dataflow_Type.inputs(ty)))(inputIndex);
            if (v1 instanceof Data_Maybe.Just) {
                return Data_Map_Internal.singleton(Lunarbox_Data_Editor_Node_PinLocation.OutputPin.value)(v1.value0);
            };
            if (v1 instanceof Data_Maybe.Nothing) {
                return Data_Monoid.mempty(Data_Map_Internal.monoidMap(Lunarbox_Data_Editor_Node_PinLocation.ordPin));
            };
            throw new Error("Failed pattern match at Lunarbox.Capability.Editor.Type (line 96, column 53 - line 98, column 20): " + [ v1.constructor.name ]);
        };
    };
};
var eqCc = Color.eqColor;
var semigroupCc = new Data_Semigroup.Semigroup(function (c) {
    return function (c$prime) {
        if (Data_Eq.eq(eqCc)(c)(unknownColor)) {
            return c$prime;
        };
        if (Data_Eq.eq(eqCc)(c$prime)(unknownColor)) {
            return c;
        };
        if (Data_Boolean.otherwise) {
            return CombinableColor(Color_Blending.blend(Color_Blending.Overlay.value)(c)(c$prime));
        };
        throw new Error("Failed pattern match at Lunarbox.Capability.Editor.Type (line 44, column 1 - line 52, column 36): " + [ c.constructor.name, c$prime.constructor.name ]);
    };
});
var monoidCc = new Data_Monoid.Monoid(function () {
    return semigroupCc;
}, unknownColor);
var typeToColor = function (v) {
    if (v instanceof Lunarbox_Data_Dataflow_Type.TConstant && v.value1.length === 0) {
        if (Data_Eq.eq(Lunarbox_Data_Dataflow_Type.typeEq)(v)(Lunarbox_Data_Dataflow_Type.typeString)) {
            return Color.rgb(97)(196)(35);
        };
        if (Data_Eq.eq(Lunarbox_Data_Dataflow_Type.typeEq)(v)(Lunarbox_Data_Dataflow_Type.typeBool)) {
            return Color.rgb(193)(71)(53);
        };
        if (Data_Eq.eq(Lunarbox_Data_Dataflow_Type.typeEq)(v)(Lunarbox_Data_Dataflow_Type.typeNumber)) {
            return Color.rgb(35)(78)(196);
        };
        if (Data_Boolean.otherwise) {
            return unknownColor;
        };
    };
    if (v instanceof Lunarbox_Data_Dataflow_Type.TConstant) {
        return Data_Newtype.unwrap(newtypeCc)(Data_Foldable.fold(Data_Foldable.foldableArray)(monoidCc)(Data_Functor.map(Data_Functor.functorArray)(Data_Functor.map(Data_Functor.functorFn)(CombinableColor)(typeToColor))(v.value1)));
    };
    if (v instanceof Lunarbox_Data_Dataflow_Type.TVariable) {
        var shade = Lunarbox_Math_SeededRandom.seededInt(Data_Show.show(Lunarbox_Data_Dataflow_Type.tvarShow)(v.value1))(50)(220);
        return Color.rgb(shade)(shade)(shade);
    };
    throw new Error("Failed pattern match at Lunarbox.Capability.Editor.Type (line 58, column 1 - line 58, column 29): " + [ v.constructor.name ]);
};
var generateColorMap = function (v) {
    return function (v1) {
        if (v1 instanceof Lunarbox_Data_Editor_Node.InputNode) {
            return Data_Monoid.mempty(Data_Map_Internal.monoidMap(Lunarbox_Data_Editor_Node_PinLocation.ordPin));
        };
        var pairs = Data_Filterable.filterMap(Data_Filterable.filterableList)(function (pin) {
            return Data_Functor.map(Data_Maybe.functorMaybe)(Data_Functor.map(Data_Functor.functorFn)(Data_Tuple.Tuple.create(pin))(typeToColor))(v(pin));
        })(pinLocations(v1));
        return Data_Map_Internal.fromFoldable(Lunarbox_Data_Editor_Node_PinLocation.ordPin)(Data_List_Types.foldableList)(pairs);
    };
};
module.exports = {
    typeToColor: typeToColor,
    generateColorMap: generateColorMap,
    prettify: prettify,
    inputNodeType: inputNodeType
};
